import "./k";
import { getLevelSpecs, LevelSpec } from "./cloudLoader";

// Sprite/sound caching for common assets (loaded once at startup)
loadShaderURL("filmic", null, "shaders/filmic.frag");
loadShaderURL("vgradient", null, "shaders/vgradient.frag");

// Load common sprites
loadSprite("fake", "sprites/util/fake.png");
loadSprite("frame", "sprites/util/frame.png", {
  slice9: {
    left: 60,
    right: 60,
    top: 60,
    bottom: 60,
  },
});
loadSprite("real", "sprites/util/real.png");
loadSprite("aibutton", "sprites/util/aibutton.png");
loadSprite("realbutton", "sprites/util/realbutton.png");
loadSprite("button", "sprites/util/blankbutton.png", {
  slice9: {
    left: 20,
    right: 20,
    top: 20,
    bottom: 30,
  },
});
loadSprite("back", "sprites/util/backbutton.png");
loadSprite("right", "sprites/util/right.png");
loadSprite("wrong", "sprites/util/wrong.png");
loadSprite("bg", "sprites/util/bg.png");
loadSprite("logo", "sprites/util/logo.png");

// Load common sounds
loadSound("click", "sounds/click2.ogg");
loadSound("rollover", "sounds/rollover2.ogg");
loadSound("confirm", "sounds/confirmation_002.ogg");
loadSound("win", "sounds/confirmation_001.ogg");
loadSound("error", "sounds/error_003.ogg");
loadSound("zoomIn", "sounds/maximize_003.ogg");
loadSound("zoomOut", "sounds/minimize_003.ogg");

// Extended level type that includes fileName for storage compatibility
export interface Level extends LevelSpec {
  fileName: string;
}

// LEVELS array - populated after cloud loading completes
// Access this after the loading scene has finished
export function getLevels(): Level[] {
  return getLevelSpecs().map((spec) => ({
    ...spec,
    fileName: spec.folderName, // Use folderName as fileName for storage
  }));
}

// For backward compatibility - returns the levels array
// Note: This is a getter, so it always returns current state
export const LEVELS: Level[] = new Proxy([] as Level[], {
  get(target, prop) {
    const levels = getLevels();
    if (prop === "length") return levels.length;
    if (typeof prop === "string" && !isNaN(Number(prop))) {
      return levels[Number(prop)];
    }
    if (prop === Symbol.iterator) {
      return function* () {
        for (const level of levels) yield level;
      };
    }
    return Reflect.get(levels, prop);
  },
});

// loadLevelSprites is now a no-op since assets are loaded in levelLoading scene
export async function loadLevelSprites(levelIndex: number): Promise<void> {
  // Assets are already loaded by levelLoading scene
  // This function exists for backward compatibility
}
